import { api } from "@/lib/api";

import type {
  GrossProfitReport,
  GrossProfitSourceFilter,
} from "@artisancode/api-types";

export interface GrossProfitReportParams {
  date_from?: string;
  date_to?: string;
  source?: GrossProfitSourceFilter;
  rider_id?: string;
  workspace_id?: string;
}

export const grossProfitReportService = {
  get: (params?: GrossProfitReportParams) =>
    api.get<GrossProfitReport>(
      "/gross-profit-report",
      params as Record<string, string | number | boolean | undefined>,
    ),
};
